import { z } from 'zod/v4'

export const schema = z
  .object({
    idCompany: z.string(),
    idProject: z.string().optional(),
    buildEnabled: z.boolean(),
    displayName: z.string({ message: 'Name is required' }).min(1, {
      message: 'Name is required',
    }),
    repoUrl: z.string().optional(),
    defaultBranch: z
      .string({ message: 'Default branch is required' })
      .min(1, { message: 'Default branch is required' }),
    autoDeploy: z.boolean(),
    idRemoteRepository: z.string().optional(),
    gitType: z.enum(['github', 'gitlab', 'bitbucket']),
    installCommand: z.string().nullish(),
    buildCommand: z.string().optional(),
    rootDirectory: z.string(),
    publishedDirectory: z.string(),
    indexFile: z.string(),
    errorFile: z.string().optional(),
    nodeVersion: z.string().nullish(),
    isPreviewEnabled: z.boolean().default(false),
    source: z.enum(['privateGit', 'publicGit']),
    isEnvVarProduction: z.boolean().default(true),
    isEnvVarPreview: z.boolean().default(true),
    envVars: z
      .array(
        z.object({
          key: z.string(),
          value: z.string(),
          isPreview: z.boolean().nullish(),
          isProduction: z.boolean().nullish(),
        })
      )
      .default([]),
  })
  .refine(
    (values) => {
      if (values.buildEnabled) {
        return values?.buildCommand && values?.buildCommand?.trim()?.length > 0
      }
      return true
    },
    {
      message: 'Build command is required when build is enabled',
      path: ['buildCommand'],
    }
  )
  .refine((val) => !(val.source === 'privateGit' && !val.idRemoteRepository), {
    message: 'Repository is required',
    path: ['idRemoteRepository'],
  })
  .refine((val) => !(val.source === 'publicGit' && !val.repoUrl), {
    message: 'Repository url is required',
    path: ['repoUrl'],
  })

export type CreateStaticSiteFormValues = z.input<typeof schema>
